import { Center, FlexProps, Text } from '@chakra-ui/react';

export function Loading(props: FlexProps) {
  return (
    <Center h="40vh" flexDirection="column" {...props}>
      <Text
        fontFamily="mono"
        fontSize="11px"
        letterSpacing="0.16em"
        textTransform="uppercase"
        color="text.faint"
      >
        Carregando…
      </Text>
    </Center>
  );
}
